// extracted by mini-css-extract-plugin
module.exports = {"empty-progress-card":"empty-progress-card__1fOoo","icon":"icon__9Sl0b","body":"body__2TyZy","header":"header__32NXX","text":"text__U6rhg","button":"button__2Hic-"};